import { SessionData } from "./types";

interface Props {
  data: SessionData;
  onNext: () => void;
}

export function ReviewStep({ data, onNext }: Props) {
  return (
    <div className="wizard-step">
      <header className="wizard-step-header">
        <h2>Review Your Order</h2>
        <p>Please confirm your details before continuing.</p>
      </header>

      <section className="wizard-review-section">
        <div className="wizard-label">Contact Information</div>
        <div className="wizard-review-card">
          <ReviewRow label="Name" value={data.name} />
          <ReviewRow label="Phone" value={data.phone} />
          <ReviewRow label="Email" value={data.email} />
        </div>
      </section>

      <section className="wizard-review-section">
        <div className="wizard-label">Documents</div>
        <div className="wizard-review-card">
          {data.selectedDocuments.length === 0 ? (
            <p className="wizard-muted">No documents uploaded</p>
          ) : (
            data.selectedDocuments.map((f) => (
              <div className="wizard-doc-row" key={f.name}>
                <span aria-hidden="true">📄</span> {f.name}
              </div>
            ))
          )}
        </div>
      </section>

      <section className="wizard-review-section">
        <div className="wizard-label">Pricing</div>
        <div className="wizard-review-card">
          <div className="wizard-review-price-row">
            <span>Per notarized signature</span>
            <strong>$25.00</strong>
          </div>
          <p className="wizard-muted wizard-small">
            Final cost depends on the number of signatures required.
          </p>
        </div>
      </section>

      <button type="button" className="wizard-button-primary" onClick={onNext}>
        Looks Good — Continue
      </button>
    </div>
  );
}

function ReviewRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="wizard-review-row">
      <span className="wizard-review-row-label">{label}</span>
      <span className="wizard-review-row-value">{value}</span>
    </div>
  );
}
